import React, { useMemo, useEffect, useState, useRef, useCallback } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { Typography, Button, Card, Box, TextField } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CampaignIcon from '@mui/icons-material/Campaign';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/system';
import Pagination from '@mui/material/Pagination';
import LeadService from '../../core/services/leadsService';
import toast from 'react-hot-toast';
import LinearProgress from '@mui/material/LinearProgress';
import { debounce, throttle } from 'lodash';
import { Autocomplete } from '@mui/material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
const SwitchAgentsDetails = () => {
    const theme = useTheme();
    let { id } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [FinalLoading, setFinalLoading] = useState(false);
    const [isAgent, setIsAgent] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [LeadData, setLeadData] = useState([]);
    const [shiftedAgentName, setShiftedAgentName] = useState();
    const [rowSelection, setRowSelection] = useState({});

    const abortControllerRef = useRef(null);

    const AllAgents = async () => {
        try {
            const res = await LeadService.getAllOrganizationAgent();
            if (res.data.success) {
                setIsAgent(res?.data?.agents || []); // Fallback to empty array if data is missing
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        AllAgents();
    }, []);
    const HandleChangeAgent = async (event, newValue) => {
        setSelectedValue(newValue ? newValue.id : '');
    };

    const adjustTimeBasedOnOffsetForReceivedData = (date, offsetInHours) => {
        const adjustedDate = new Date(date);
        adjustedDate.setHours(adjustedDate.getHours() + offsetInHours);
        return adjustedDate;
    };

    const adjustTimeOffSetAssignedAtForReceived = (dateString, offsetInHours) => {
        const date = new Date(dateString);
        // Convert to UTC and then apply offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        utcDate.setHours(utcDate.getHours() + offsetInHours);
        return utcDate;
    };

    const formatDateTimeIn12HourFormat = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');

        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM/PM
        hours = String(hours).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const StatusDisplayMap = {
        active: 'New',
        new: 'New',
        attempting_contact: 'Attempting Contact',
        spoke_with_customer_new: 'New',
        spoke_with_customer: 'Spoke with customer',
        appointment_set: 'Appointment Set',
        met_with_customer: 'Met with Customer',
        showing_homes: 'Showing Homes',
        submitting_offers: 'Submitting Offers',
        buy_side_contract: 'Buy Side Contract',
        under_contract_escrow: 'Under Contract',
        bamfam: 'BAMFAM',
        nurture: 'Nurture Before Sale',
        closed: 'Sale Closed',
        nurture_after_sale: 'Nurture After Sale',
        rejected: 'Rejected',
        not_interested: 'Not Interested',
        personal_lead: 'Personal Lead',
        refinance_referral: 'Refinance Referral',
        agent: 'Agent',
        bad_lead: 'Bad Lead',
        follow_up: 'Follow Up',
        buyer_broker_signed: 'Buyer Broker Signed',
        cancelled: 'Cancelled',
        valuation_appointment: 'Valuation Appointment',
        listing_appointment: 'Listing Appointment',
        listing_signed: 'Listing Signed',
        dnc: 'DNC',
    };
    const columns = useMemo(
        () => [
            {
                accessorKey: 'id',
                header: 'Sr no',
                size: 10,
                enableSorting: false,
                showColumnFilters: false,
                enableColumnFilter: false,
                muiTableBodyCellProps: {
                    align: 'left',
                },
            },
            {
                accessorFn: (row) => {
                    return row?.last_name === null
                        ? row?.first_name
                        : `${row?.first_name} ${row?.last_name}`;
                },
                header: 'Lead Name',
                enableColumnActions: false,
                showColumnFilters: false,
                enableColumnFilter: false,
                enableSorting: false,
                size: 50,
                muiTableHeadCellProps: {
                    align: 'left',
                },
                Cell: ({ row }) => (
                    <span>
                        {row?.original.last_name === null
                            ? row?.original.first_name
                            : `${row?.original.first_name} ${row?.original.last_name}`}
                    </span>
                ),
            },

            {
                accessorKey: 'email',
                header: 'Email',
                size: 50,
                showColumnFilters: false,
                enableSorting: false,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'phone',
                header: 'Phone Number',
                size: 50,
                enableSorting: false,
                showColumnFilters: false,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'status',
                enableSorting: false,
                header: 'Status',
                Cell: ({ cell }) => StatusDisplayMap[cell.getValue()] || cell.getValue(),
                size: 50,
            },
            {
                accessorFn: (row) => {
                    const assignby = row?.assignby;
                    if (!assignby) {
                        return '';
                    }
                    return assignby.last_name ? `${assignby?.name} ${assignby?.last_name}` : assignby.last_name;
                },
                header: 'Assign By',
                enableColumnActions: false,
                showColumnFilters: false,
                enableSorting: false,
                enableColumnFilter: false,
                size: 50,
                muiTableHeadCellProps: {
                    align: 'left',
                },
            },

            {
                accessorFn: (row) => {
                    if (row?.date && row?.time) {
                        const dateTimeString = `${row.date} ${row.time}`;
                        const dateTime = new Date(dateTimeString);
                        const userOffset = getUserOffset();
                        const adjustedDateTime = adjustTimeBasedOnOffsetForReceivedData(dateTime, userOffset);
                        return formatDateTimeIn12HourFormat(adjustedDateTime);
                    }
                    return '';
                },
                header: 'Appt Date/Time',
                size: 50,
                showColumnFilters: false,
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: 'Created at',
                size: 50,
                showColumnFilters: false,
                enableSorting: false,
                enableColumnFilter: false,
                accessorFn: (row) => {
                    if (row?.created_at) {
                        const updatedAt = row?.created_at;
                        const dateTime = new Date(updatedAt);
                        const userOffset = getUserOffset();
                        const adjustedDateTime = adjustTimeOffSetAssignedAtForReceived(dateTime, userOffset);
                        return formatDateTimeIn12HourFormat(adjustedDateTime);
                    }
                    return '';
                },
            },
        ],
        [navigate]
    );

    const GetAllLeads = async (
        id,
        currentPage,
        signal

    ) => {
        try {
            setIsLoading(true);
            const res = await LeadService.shiftedOrganizationAgentAssignments(id, currentPage, { signal });
            if (res?.data?.success) {
                setLeadData(res?.data?.data?.data);
                setShiftedAgentName(res?.data?.shifted_agent);
                setCurrentPage(res?.data?.data?.current_page || 1);
                setTotalPages(Math.ceil((res?.data?.data?.total || 0) / (res?.data?.data?.per_page || 1)));
            } else {
                toast.error('Failed to fetch leads');
            }
        } catch (error) {
            toast.error(error.message || 'An error occurred');
            console.error(error);
        } finally {
            setIsLoading(false);
            setIsLoading(false);
        }
    };
    const throttledGetLeads = useCallback(
        throttle((id, page, signal) => {
            GetAllLeads(id, page, signal);
        }, 2000),
        []
    );

    const fetchLeads = useCallback(
        debounce((id, page, selectedValue) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetLeads(id, page, selectedValue, abortController.signal);
        }, 300),
        [throttledGetLeads]
    );
    useEffect(() => {
        fetchLeads(id, currentPage,);
    }, [id, currentPage, fetchLeads]);

    const handleAssignLeadToNewAgent = async (id, selectedValue, rowSelection) => {
        try {
            if (selectedValue === null || selectedValue === '') {
                return toast.error("please select the the agent")
            } else if (rowSelection.length === 0) {
                return toast.error("Please select atleast one lead to assign agent")
            }
            const SelectedLeadValue = Object.keys(rowSelection)
            setFinalLoading(true)
            const res = await LeadService.assignLeadToNewAgent(id, selectedValue, SelectedLeadValue)
            if (res.data.success) {  
                if(res.data.message === 'Leads assigned successfully, but some leads remain with the shifted agent.'){
                    fetchLeads(id, currentPage,);
                    setRowSelection({})
                    setSelectedValue('')
                    toast.success(res.data.message)
                }
                else if (res.data.message === 'Leads assigned successfully and shifted leads deleted.') {
                    navigate('/switch-agent');
                    toast.success(res.data.message)
                }
                return
            }

        } catch (error) {
            toast.error(error.message)

        } finally {
            setFinalLoading(false)
        }

    }
    const HandleBackNavigate = () => {
        navigate('/switch-agent');
        return
    }


    return (
        <div>
            <ScrollAnimation animateIn="fadeIn">
                <div style={{ marginBottom: '15px' }}> {isLoading || FinalLoading && <LinearProgress />}</div>
                <Box>
                    <Button onClick={HandleBackNavigate}> <ArrowBackIosIcon fontSize={'medium'} style={{ color: '#c6c0c0' }} /></Button>

                </Box>
                <ThemeProvider theme={theme}>
                    <GlobalStyles
                        styles={{
                            '::-webkit-scrollbar': {
                                width: '14px', // Set the desired width for the scrollbar
                            },
                            '::-webkit-scrollbar-thumb': {
                                backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                borderRadius: '10px', // Set the border radius for a rounded effect
                            },
                        }}
                    />
                    <Box style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <Typography style={{ fontSize: '36px', fontWeight: '700', marginLeft: '12px' }}>{shiftedAgentName?.name}{' '}{shiftedAgentName?.last_name} Assignments</Typography></Box>

                    <Card
                        variant="outlined"
                        sx={{
                            borderRadius: '22px',
                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                            background: '#ebebeb',
                            width: 'auto',
                            marginBottom: '20px'

                        }}
                    >
                        <Box style={{ margin: '10px', padding: '14px' }}>
                            <div style={{ display: 'flex' }}>
                                <CampaignIcon sx={{ color: '#5379BD' }} />
                                .<Typography style={{ fontSize: '14px', color: '#da4545', fontFamily: 'monospace', marginTop: '1px', marginLeft: '5px' }}>
                                    Agent ({shiftedAgentName?.name}{' '}{shiftedAgentName?.last_name}) has requested to join another organization, we request you as
                                    organization admin to approve his request. In order to do so you can keep agent's
                                    leads as organization leads by assigning agent's leads to any agent in your organization,
                                    and leave the rest which you want him to keep as his personal leads.
                                </Typography>
                            </div>
                        </Box>
                    </Card>
                    <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px', marginBottom: '12px', gap: '12px' }}>

                        <Autocomplete
                            options={isAgent}
                            getOptionLabel={(agent) => agent?.full_name || ''} // Fallback for undefined agent
                            renderInput={(params) => <TextField {...params} label="Select Agent" />}
                            sx={{ width: 320 }}
                            value={isAgent.find((agent) => agent.id === selectedValue) || null} // Ensuring isAgent is always an array
                            onChange={HandleChangeAgent}
                            disabled={isLoading}
                        />
                        <Button style={{ borderRadius: '12px', backgroundColor: '#5379bd' }} variant="contained" onClick={() => handleAssignLeadToNewAgent(id, selectedValue, rowSelection)}>Assign Lead</Button>
                    </Box>
                    <div style={{ width: '100%', overflow: 'visible' }}>
                        <Card style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                            <MaterialReactTable
                                columns={columns}
                                data={LeadData}
                                state={{ rowSelection, isLoading: isLoading }}
                                muiCircularProgressProps={{
                                    color: 'secondary',
                                    thickness: 5,
                                    size: 55,
                                }}
                                muiSkeletonProps={{
                                    animation: 'pulse',
                                    height: 28,
                                }}
                                enablePagination={false}
                                enableTopToolbar={true}
                                enableDensityToggle={false}
                                enableHiding={false}
                                showSkeletons={false}
                                enableStickyHeader={true}
                                enableColumnFilterModes={false}
                                enableColumnActions={false}
                                enableColumnOrdering={false}
                                enableFullScreenToggle={false}
                                enableColumnFilters={false}
                                enableGlobalFilter={false}
                                initialState={{
                                    showColumnFilters: false,
                                    showGlobalFilter: false,
                                }}
                                enableRowSelection={true}
                                onRowSelectionChange={setRowSelection}
                                getRowId={(row) => row?.id}
                            />
                        </Card>

                        <Pagination
                            count={totalPages}
                            color="primary"
                            page={currentPage}
                            onChange={(event, value) => setCurrentPage(value)}
                            style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                        />
                    </div>
                </ThemeProvider>
            </ScrollAnimation>
        </div>
    );
};

export default SwitchAgentsDetails;
